import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SwiperModule } from 'src/app/theme/components/swiper/swiper.module';
import { LoaderInlineComponent } from '../components/loader-inline/loader-inline.component';
import { AboutForSaleComponent } from '../components/pages/about-for-sale/about-for-sale.component';
import { AboutKaupsaganComponent } from '../components/pages/about-kaupsagan/about-kaupsagan.component';
import { AboutSellComponent } from '../components/pages/about-sell/about-sell.component';
import { AboutSoluadilarFasteignasolurComponent } from '../components/pages/about-soluadilar-fasteignasolur/soluadilar-fasteignasolur.component';
import { AboutVerdmatComponent } from '../components/pages/about-verdmat/about-verdmat.component';
import { DirectivesModule } from '../theme/directives/directives.module';
import { PipesModule } from '../theme/pipes/pipes.module';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ClientsComponent } from './clients/clients.component';
import { CommentsComponent } from './comments/comments.component';
import { CompareOverviewComponent } from './compare-overview/compare-overview.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DialogHeaderControlsComponent } from './dialog-header-controls/dialog-header-controls.component';
import { GetInTouchComponent } from './get-in-touch/get-in-touch.component';
import { HeaderCarouselComponent } from './header-carousel/header-carousel.component';
import { HeaderImageComponent } from './header-image/header-image.component';
import { HeaderMapComponent } from './header-map/header-map.component';
import { HeaderVideoComponent } from './header-video/header-video.component';
import { LoadMoreComponent } from './load-more/load-more.component';
import { LogoComponent } from './logo/logo.component';
import { MissionComponent } from './mission/mission.component';
import { OurAgentsComponent } from './our-agents/our-agents.component';
import { OurServicesComponent } from './our-services/our-services.component';
import { PropertiesCarouselComponent } from './properties-carousel/properties-carousel.component';
import { PropertiesForSaleSearchComponent } from './properties-for-sale-search/properties-for-sale-search.component';
import { PropertiesSearchResultsFiltersComponent } from './properties-search-results-filters/properties-search-results-filters.component';
import { PropertiesSearchComponent } from './properties-search/properties-search.component';
import { PropertiesSoldSearchHomeComponent } from './properties-sold-search-home/properties-sold-search-home.component';
import { PropertiesToolbarComponent } from './properties-toolbar/properties-toolbar.component';
import { PropertyItemForSaleComponent } from './property-item-for-sale/property-item-for-sale.component';
import { PropertyItemSoldComponent } from './property-item-sold/property-item-sold.component';
import { RatingComponent } from './rating/rating.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    SwiperModule,
    TranslateModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    NgScrollbarModule,
    GoogleMapsModule,
    PipesModule,
    DirectivesModule
  ],
  exports: [
    RouterModule,
    ReactiveFormsModule,
    SwiperModule,
    TranslateModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    NgScrollbarModule,
    GoogleMapsModule,
    PipesModule,
    DirectivesModule,
    LogoComponent,
    HeaderImageComponent,
    HeaderCarouselComponent,
    PropertyItemForSaleComponent,
    PropertyItemSoldComponent,
    LoadMoreComponent,
    PropertiesToolbarComponent,
    PropertiesForSaleSearchComponent,
    CompareOverviewComponent,
    RatingComponent,
    PropertiesSearchResultsFiltersComponent,
    PropertiesCarouselComponent,
    ClientsComponent,
    GetInTouchComponent,
    CommentsComponent,
    TestimonialsComponent,
    OurAgentsComponent,
    MissionComponent,
    OurServicesComponent,
    HeaderMapComponent,
    HeaderVideoComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    DialogHeaderControlsComponent,
    LoaderInlineComponent,
    PropertiesSearchComponent,
    PropertiesSoldSearchHomeComponent,
    AboutSellComponent,
    AboutKaupsaganComponent,
    AboutForSaleComponent,
    NgxChartsModule,
    AboutSoluadilarFasteignasolurComponent,
    AboutVerdmatComponent
  ],
  declarations: [
    LogoComponent,
    HeaderImageComponent,
    HeaderCarouselComponent,
    PropertyItemForSaleComponent,
    PropertiesSearchComponent,
    PropertiesSoldSearchHomeComponent,
    PropertyItemSoldComponent,
    LoadMoreComponent,
    PropertiesToolbarComponent,
    PropertiesForSaleSearchComponent,
    CompareOverviewComponent,
    RatingComponent,
    PropertiesSearchResultsFiltersComponent,
    PropertiesCarouselComponent,
    ClientsComponent,
    GetInTouchComponent,
    CommentsComponent,
    TestimonialsComponent,
    OurAgentsComponent,
    MissionComponent,
    OurServicesComponent,
    HeaderMapComponent,
    HeaderVideoComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    DialogHeaderControlsComponent,
    LoaderInlineComponent,
    AboutSellComponent,
    AboutKaupsaganComponent,
    AboutForSaleComponent,
    AboutSoluadilarFasteignasolurComponent,
    AboutVerdmatComponent
  ]
})
export class SharedModule { }
